// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M8 4L4 8L8 12M4 8L12 8'];
